import React from "react"
import { Field, FieldArray } from "formik"
import { Translate } from "utils/i18n-shim"
import { Grid } from "@mui/material"
import { TextField } from "shared/ui/berry-jass-formik"
import { LocationsSection } from "entities/location"
import { TagsSection } from "./TagsSection"

export const DuplicateOrderForm = ({ order, japCustomerId }) => {
  return (
    <Grid container rowGap={3}>
      <Grid item md={12}>
        <Field
          required
          fullWidth
          name="title"
          label={<Translate value="duplicate-job.dialog.form.vacancy-title" />}
          component={TextField}
        />
      </Grid>
      <Grid item md={12}>
        <Field
          fullWidth
          disabled
          name="sourceLocations"
          label={
            <Translate value="duplicate-job.dialog.form.source-locations" />
          }
          component={TextField}
          multiline
          minRows={3}
        />
      </Grid>
      <Grid item md={12}>
        <FieldArray name="locations">
          {(props) => {
            return <LocationsSection {...props} />
          }}
        </FieldArray>
      </Grid>
      <Grid item md={12}>
        <TagsSection order={order} japCustomerId={japCustomerId} />
      </Grid>
    </Grid>
  )
}
